import {Routes, Route, Navigate} from 'react-router-dom'
import {PageLink, PageTitle} from '../../../_metronic/layout/core/PageData'

import {useIntl} from 'react-intl'
import {EventsRecap} from './EventsRecap'
import {EventsTrend} from './EventsTrend'
import {EventsByCategory} from './EventsByCategory'
import {DeviceEvents} from './DeviceEvents'
import {DeviceEventsComparison} from './DeviceEventsComparison'
import {DeviceEventsTrend} from './DeviceEventsTrend'
import { SearchKeywords } from './SearchKeywords'

const DeviceReportRoutes = () => {
  const intl = useIntl()
  const breadcrumbs: Array<PageLink> = [
    {
      title: 'Arteco Insight',
      path: '',
      isSeparator: false,
      isActive: false,
      disableLink: true,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
    {
      title: intl.formatMessage({id: 'MENU.REPORT_DEVICE'}),
      path: '',
      isSeparator: false,
      isActive: false,
      disableLink: true,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
  ]

  return (
    <Routes>
      <Route
        path='recap'
        element={
          <>
            <PageTitle breadcrumbs={breadcrumbs}>
              {intl.formatMessage({id: 'MENU.DIAGNOSTICS.RECAP'})}
            </PageTitle>
            <EventsRecap />
          </>
        }
      />
      <Route
        path='trend'
        element={
          <>
            <PageTitle breadcrumbs={breadcrumbs}>
              {intl.formatMessage({id: 'MENU.DIAGNOSTICS.TREND'})}
            </PageTitle>
            <EventsTrend />
          </>
        }
      />
      <Route
        path='category'
        element={
          <>
            <PageTitle breadcrumbs={breadcrumbs}>
              {intl.formatMessage({id: 'MENU.DIAGNOSTICS.CATEGORY'})}
            </PageTitle>
            <EventsByCategory />
          </>
        }
      />
      <Route
        path='events'
        element={
          <>
            <PageTitle breadcrumbs={breadcrumbs}>
              {intl.formatMessage({id: 'MENU.REPORT_DEVICE.EVENTS'})}
            </PageTitle>
            <DeviceEvents />
          </>
        }
      />
      <Route
        path='comparison'
        element={
          <>
            <PageTitle breadcrumbs={breadcrumbs}>
              {intl.formatMessage({id: 'MENU.REPORT_DEVICE.COMPARISON'})}
            </PageTitle>
            <DeviceEventsComparison />
          </>
        }
      />
      <Route
        path='device-trend'
        element={
          <>
            <PageTitle breadcrumbs={breadcrumbs}>
              {intl.formatMessage({id: 'MENU.REPORT_DEVICE.TREND'})}
            </PageTitle>
            <DeviceEventsTrend />
          </>
        }
      />

      <Route
        path='keywords'
        element={
          <>
            <PageTitle breadcrumbs={breadcrumbs}>
              {intl.formatMessage({id: 'MENU.REPORT_DEVICE.SARCH_KEYWORD'})}
            </PageTitle>
            <SearchKeywords />
          </>
        }
      />

      <Route path='*' element={<Navigate to='/error/404' />} />
    </Routes>
  )
}

export {DeviceReportRoutes}
